import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { userContext } from 'contexts/userContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';

import Card from 'components/Account/Common/Card/Card';
import ModalSuccessCatalogRequest from 'components/Modals/ModalSuccessCatalogRequest/ModalSuccessCatalogRequest';
import Button from 'components/Common/Button/Button';
import CatalogImage from 'components/Common/CatalogImage/CatalogImage';
import { useCustomer } from 'hooks/useCustomer';
import useEnv from 'hooks/useEnv';
import { fetcherWithBody } from 'services/fetcher';
import { gtmAfiEventLab } from 'services/gtm';
import { pushGtmEvent } from 'services/gtm/gtmEvents';

import styles from './CatalogRequest.module.scss';

function CatalogRequest(): JSX.Element {
  const { t } = useTranslation(['catalogRequestPage']);
  const { gtmUserCookie } = useContext(userContext);
  const { urlApiCustomer } = useEnv();
  const { customer } = useCustomer();
  const { P: primaryAddress } = customer?.addresses ?? {};
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);
  const labels = [
    {
      name: 'fullName',
      libelle: `${customer?.civility} ${customer?.firstName} ${customer?.lastName}`,
    },
    {
      name: 'street',
      libellePrimary: primaryAddress?.street,
    },
    {
      name: 'nameComplement',
      libellePrimary: primaryAddress?.nameComplement,
    },
    {
      name: 'nameAddress',
      libellePrimary: primaryAddress?.nameAddress,
    },
    {
      name: 'saidPlace',
      libellePrimary: primaryAddress?.saidPlace,
    },
    {
      name: 'postCodeAndCity',
      libellePrimary: `${primaryAddress?.postalCode} ${primaryAddress?.city}`,
    },
  ];

  const handleClick = async () => {
    pushGtmEvent({
      event: '_catalog_request',
    });

    const response = await fetcherWithBody(
      `${urlApiCustomer}/catalog/request`,
      { email: customer?.email },
      true
    );

    if (response.ok) {
      gtmAfiEventLab(
        location.pathname,
        'afiEvent',
        'Demande de catalogue',
        'Inscription',
        gtmUserCookie
      );

      setOpenModal(true);
    }
  };

  return (
    <>
      <Card classes={{ container: styles.container }}>
        <div className={styles.title}>
          <label>{t('LABEL_CATALOG_REQUEST_TITLE')}</label>
        </div>
        <label className={styles.subtitle}>
          <FontAwesomeIcon icon={faChevronRight} />
          <span>{t('LABEL_CATALOG_REQUEST_SUBTITLE')}</span>
        </label>
        <div className={styles.content}>
          <div className={styles.formContainer}>
            <div className={styles.formRequest}>
              {labels.map(label => {
                return (
                  <label key={label.name}>
                    {label.libellePrimary || label.libelle}
                  </label>
                );
              })}
              <div className={styles.button}>
                <Button onClick={handleClick}>
                  {t('LABEL_CONFIRM', { ns: 'translation' })}
                </Button>
              </div>
            </div>
            <CatalogImage
              classes={{
                wrapper: styles.imageWrapper,
                image: styles.image,
              }}
            />
          </div>
        </div>
      </Card>
      <ModalSuccessCatalogRequest
        isOpen={openModal}
        closeModal={handleCloseModal}
      />
    </>
  );
}

export default CatalogRequest;
